import { IResultStamp } from "@/api/AppApi/common-interfaces/IResultStamp";
import ApiService from "@/api/baseApi/api-service";
import { Config } from "../../config";
import {
  IChangePasswordParams,
  IGetUserProfile,
  IOtpSignInParams,
  IPostChangePassword,
  IPostRegister,
  IPostResetPasswordParams,
  IPostVerify,
  IRegisterParams,
  ISendVerificationCodeParams,
  ISendVerifyForgetPasswordParams,
  ISignInParams,
  ISocialLoginParams,
  IUpdateProfile,
  IUpdateSettings,
  IVerifyParams,
} from "./interfaces/IAuth";

const subBaseUrl = "/users";

const URLs = {
  register: subBaseUrl + "/register", //post
  signIn: subBaseUrl + "/login", //post
  logout: subBaseUrl + "/logout",
  socialSignIn: subBaseUrl + "/login/social", //post
  checkAccountExist: subBaseUrl + "/check", //not used
  // verify: subBaseUrl + "/verify", //not used
  sendVerificationCode: subBaseUrl + "/otp",
  verifyMobile: subBaseUrl + "/mobile",
  verifyEmail: subBaseUrl + "/email",
  updatePassword: subBaseUrl + "/password",
  forgetPassword: subBaseUrl + "/password/forget",
  verifyForgetPassword: subBaseUrl + "/password/verify-code",
  resetPassword: subBaseUrl + "/password/reset",
  otpLogin: subBaseUrl + "/login/otp",
  profile: subBaseUrl + "/profile",
  updateProfie: subBaseUrl + "/profile", //put, same as get profile
  updateSettings: subBaseUrl + "/settings",
  refreshToken: "/users/refresh-token",
};
class ApiAuth extends ApiService {
  constructor(config: Config) {
    super({ ...config });
  }
  register = (
    body: IRegisterParams,
    params?: {
      fbc?: string | null;
      fbp?: string | null;
      event_id?: string;
      ttp?: string | null;
      ttclid?: string | null;
      twclid?: string | null;
      fb_login_id?: string | null;
    },
  ): Promise<IPostRegister> => this.post(URLs.register, { ...body }, { params });
  signin = (body: ISignInParams): Promise<IPostRegister> =>
    this.post(URLs.signIn, { ...body });
  logout = (): Promise<IResultStamp> => this.post(URLs.logout, {});
  otpLogin = (body: IOtpSignInParams): Promise<IPostRegister> =>
    this.post(URLs.otpLogin, { ...body });
  socialLogin = (body: ISocialLoginParams): Promise<IPostRegister> =>
    this.post(URLs.socialSignIn, { ...body });
  checkAccountExist = (username: string): Promise<IResultStamp> =>
    this.post(URLs.checkAccountExist, { username: username });
  sendVerificationCode = (
    body: ISendVerificationCodeParams,
  ): Promise<IResultStamp> => this.post(URLs.sendVerificationCode, { ...body });
  verifyMobile = (
    body: IVerifyParams,
    params?: {
      fbc?: string | null;
      fbp?: string | null;
      event_id?: string;
      ttp?: string | null;
      ttclid?: string | null;
      twclid?: string | null;
      fb_login_id?: string | null;
    },
  ): Promise<IPostVerify> => this.put(URLs.verifyMobile, { ...body }, { params });
  verifyEmail = (
    body: IVerifyParams,
    params?: {
      fbc?: string | null;
      fbp?: string | null;
      event_id?: string;
      ttp?: string | null;
      ttclid?: string | null;
      twclid?: string | null;
    },
  ): Promise<IPostVerify> => this.put(URLs.verifyEmail, { ...body }, { params });
  forgetPassword = (body: ISendVerificationCodeParams): Promise<IResultStamp> =>
    this.post(URLs.forgetPassword, { ...body });
  verifyForgetPassword = (
    body: ISendVerifyForgetPasswordParams,
  ): Promise<IResultStamp> => this.post(URLs.verifyForgetPassword, { ...body });
  resetPassword = (body: IPostResetPasswordParams): Promise<IResultStamp> =>
    this.post(URLs.resetPassword, { ...body });
  updatePassword = (
    body: IChangePasswordParams,
  ): Promise<IPostChangePassword> => this.put(URLs.updatePassword, { ...body });
  getProfile = (): Promise<IGetUserProfile> => this.get(URLs.profile, {});
  updateProfile = (body: IUpdateProfile): Promise<IResultStamp> =>
    this.put(URLs.updateProfie, { ...body });
  updateSettings = (body: IUpdateSettings): Promise<IResultStamp> =>
    this.put(URLs.updateSettings, { ...body });
  // refreshToken = (): Promise<IResultStamp> => {
  //   const refreshToken = getRefreshToken();
  //   return this.post(URLs.refreshToken, {refresh_token: refreshToken });
  // };
}
export default ApiAuth;
